import { IOnInit } from "angular";

export class ThreeRiversMachineTypeIdDetailViewComponentController
  implements IOnInit
{
  readonly typeId: any;
  readonly progressiveCalculatedFields: any;
  showProgressiveCalculatedFields: boolean = false;

  static $inject = [];

  $onInit() {
    this.showProgressiveCalculatedFields =
      !!this.progressiveCalculatedFields.ProgressiveDefinitionId;
  }

  getProgressiveCalculatedFieldsForGameConfig(gameConfig: any) {
    return this.progressiveCalculatedFields.MachineGameConfigurationsCalculatedFields.find(
      (f: any) => f.GameConfig.Id === gameConfig.Id
    );
  }
}
